import { IMovableTextBoxItemBean } from "../../../infrastructure/document/ver2/beans/items";
import { MovableTextBoxInputMethodKinds } from "../inputMethodKinds";
import { RelationalActionKinds } from "..";

export type MovableTextBoxInputMethodOptionKinds
  = "Normal"           // 通常
  | "MKSTemplate"      // MKSテンプレート
  | "DynamicTemplate"; // DYNAMICテンプレート

const deciders: { [K in MovableTextBoxInputMethodOptionKinds]: (bean: IMovableTextBoxItemBean) => boolean } = {
  Normal:          undefined, // otherwiseで返すので定義しない
  MKSTemplate:     bean => (bean.relationalItems && !!bean.relationalItems.find(i => i.relationalActionType === RelationalActionKinds.MksTemplateFormat)),
  DynamicTemplate: bean => (bean.relationalItems && !!bean.relationalItems.find(i => i.relationalActionType === RelationalActionKinds.DynamicTemplateFormat)),
};

const defaultInputMethodKinds: { [K in MovableTextBoxInputMethodOptionKinds]: MovableTextBoxInputMethodKinds } = {
  Normal:          MovableTextBoxInputMethodKinds.None,
  MKSTemplate:     MovableTextBoxInputMethodKinds.MKSTemplate,
  DynamicTemplate: MovableTextBoxInputMethodKinds.DynamicTemplate,
};

const hasDictionaryProperty = (key: string): key is MovableTextBoxInputMethodOptionKinds => deciders.hasOwnProperty(key);

export namespace MovableTextBoxInputMethodOptionKinds {
  export const Normal: MovableTextBoxInputMethodOptionKinds = "Normal";
  export const MKSTemplate: MovableTextBoxInputMethodOptionKinds = "MKSTemplate";
  export const DynamicTemplate: MovableTextBoxInputMethodOptionKinds = "DynamicTemplate";

  export const toInputMethodOptionKinds = (bean: IMovableTextBoxItemBean): MovableTextBoxInputMethodOptionKinds => {
    for (const key in deciders) {
      if (hasDictionaryProperty(key) && deciders[key] != null && deciders[key](bean)) {
        return key;
      }
    }
    return Normal;
  };

  export const getDefualtInputMethodKind = (optionKind: MovableTextBoxInputMethodOptionKinds): MovableTextBoxInputMethodKinds => {
    return defaultInputMethodKinds[optionKind];
  };
}
